module.exports = __webpack_public_path__ + "img/horizontal_4_5_pp2_9016.a15fc6d7.png";